import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3B6EC96B-24CB-4CCE-AE9F-AA1787987C63
 * name arrow-expand-vertical
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-expand-vertical.svg
 * tags
 * - Arrow 
 */
export const ArrowExpandVerticalIcon = createSvgIcon(<><path d="M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z" /></>, 'ArrowExpandVerticalIcon');
export default ArrowExpandVerticalIcon